(() => {
  class HelpCenterV2 {
    constructor(root) {
      this.root = root;
      this.search = root.querySelector('[data-help-search]');
      this.navItems = Array.from(root.querySelectorAll('[data-help-nav]'));
      this.categories = Array.from(root.querySelectorAll('[data-help-category]'));
      this.empty = root.querySelector('[data-help-empty]');
      this.activeId = this.navItems.find((item) => item.classList.contains('is-active'))?.dataset.helpNav
        || this.categories[0]?.dataset.helpCategory
        || '';
      this.bind();
      this.showCategory(this.activeId, false);
      this.syncAnswers();
    }

    normalize(value) {
      return (value || '').toString().normalize('NFKC').toLowerCase().replace(/\s+/g, ' ').trim();
    }

    bind() {
      this.navItems.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const id = button.dataset.helpNav;
          if (!id || id === this.activeId) return;
          this.clearSearch();
          this.showCategory(id, true);
        });
      });

      if (this.search) {
        this.search.addEventListener('input', () => this.filter(this.search.value));
      }

      this.root.querySelectorAll('.help-center__qa-card details').forEach((details) => {
        details.addEventListener('toggle', () => this.setAnswerState(details));
      });
    }

    clearSearch() {
      if (!this.search || !this.search.value) return;
      this.search.value = '';
      this.resetQuestionVisibility();
    }

    setActiveNav(id) {
      this.navItems.forEach((item) => {
        const active = item.dataset.helpNav === id;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    showCategory(id, animate = true) {
      const next = this.categories.find((category) => category.dataset.helpCategory === id);
      if (!next) return;

      this.activeId = id;
      this.setActiveNav(id);

      this.categories.forEach((category) => {
        const active = category === next;
        category.classList.toggle('is-active', active);
        category.hidden = !active;
      });

      if (animate) {
        next.classList.remove('is-switching');
        void next.offsetWidth;
        next.classList.add('is-switching');
      }

      if (this.empty) this.empty.hidden = next.querySelectorAll('[data-help-question]:not([hidden])').length > 0;
    }

    resetQuestionVisibility() {
      this.categories.forEach((category) => {
        category.querySelectorAll('[data-help-question]').forEach((question) => { question.hidden = false; });
      });
      this.navItems.forEach((button) => { button.hidden = false; });
      if (this.empty) this.empty.hidden = true;
    }

    filter(rawQuery) {
      const query = this.normalize(rawQuery);
      if (!query) {
        this.resetQuestionVisibility();
        this.showCategory(this.activeId || this.categories[0]?.dataset.helpCategory, false);
        return;
      }

      let firstMatchingId = '';
      let totalMatches = 0;

      this.categories.forEach((category) => {
        let categoryMatches = 0;
        category.querySelectorAll('[data-help-question]').forEach((question) => {
          const haystack = this.normalize(question.dataset.searchText || question.textContent);
          const matched = haystack.includes(query);
          question.hidden = !matched;
          if (matched) categoryMatches += 1;
        });
        if (categoryMatches > 0 && !firstMatchingId) firstMatchingId = category.dataset.helpCategory;
        totalMatches += categoryMatches;
      });

      this.navItems.forEach((button) => {
        const category = this.categories.find((item) => item.dataset.helpCategory === button.dataset.helpNav);
        button.hidden = !category || category.querySelectorAll('[data-help-question]:not([hidden])').length === 0;
      });

      if (firstMatchingId) this.showCategory(firstMatchingId, false);
      else {
        this.categories.forEach((category) => { category.hidden = true; category.classList.remove('is-active'); });
        this.navItems.forEach((item) => item.classList.remove('is-active'));
      }
      if (this.empty) this.empty.hidden = totalMatches !== 0;
    }

    setAnswerState(details) {
      const answer = details.querySelector('.help-center__answer-wrap');
      if (answer) answer.setAttribute('aria-hidden', details.open ? 'false' : 'true');
    }

    syncAnswers() {
      this.root.querySelectorAll('.help-center__qa-card details').forEach((details) => this.setAnswerState(details));
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-help-center]').forEach((root) => {
      if (root.dataset.helpCenterV2Ready === 'true') return;
      root.dataset.helpCenterV2Ready = 'true';
      new HelpCenterV2(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
